import { FileUpload } from "./FileUpload";

export const initialServices = [
  {
    id: 1,
    name: "Consent Page",
    paramName: "consent",
    isActive: false,
    description: "Here you can place your consent",
    params: [
      { id: "userTitle", type: "input", value: "", placeholder: "Title" },
      { id: "url", type: "input", value: "", placeholder: "Rules URL" },
      {
        id: "linkMask",
        type: "input",
        value: "",
        placeholder: "Rules URL Link Name",
      },
    ],
  },
  {
    id: 2,
    name: "Phone Verification",
    paramName: "veriphone",
    isActive: false,
    isOpen: false,
    description:
      "This service allows to check if a phone number belongs to a particular person",
    params: [
      {
        id: "operatorSelection",
        type: "radio-group",
        enabled: true,
        value: "all",
        options: [
          {
            label: "All Operators",
            value: "all",
            enabled: false,
          },
          {
            label: "Custom",
            value: "custom",
            enabled: false,
            params: [
              {
                id: "Mobile Citizens Database (MCD)",
                enabled: false,
                value: "egov-bmg",
                type: "checkbox",
              },
              {
                id: "Kcell",
                enabled: false,
                value: "kcell",
                type: "checkbox",
              },
              {
                id: "Tele2",
                enabled: false,
                value: "tele2",
                type: "checkbox",
              },
            ],
          },
        ],
      },
      {
        id: "Allow failure",
        enabled: false,
        value: "false",
        paramName: "allow_failure",
        type: "checkbox-select",
        selectValue: "false",
        options: ["true", "false"],
      },
      {
        id: "Timeout",
        enabled: false,
        value: 180,
        paramName: "timeout",
        type: "checkbox-select",
        selectValue: 60,
        options: [60, 120, 180],
      },
      {
        id: "Max retries",
        enabled: false,
        value: 3,
        paramName: "max_retries",
        type: "checkbox-select",
        selectValue: 1,
        options: [1, 2, 3],
      },
    ],
  },
  {
    id: 3,
    name: "Document Recognition",
    paramName: "veridoc",
    isActive: false,
    isOpen: false,
    description:
      "This service allows to recognize and exctract data from a person’s document with 3 different options: VeriDoc (Document Scan & Recognition), eGov Digital Document by Code / QR, eGov Digital Document by SMS",
    params: [
      {
        id: "VeriDoc (Scan & Recognition)",
        paramName: "scan",
        enabled: false,
        type: "checkbox",
        value: false,
        params: [
          {
            id: "Country Selector",
            enabled: false,
            paramName: "country_code",
            value: "KAZ",
            selectValue: "KAZ",
            type: "checkbox-select",
            options: ["KAZ", "RUS", "KG"],
          },
          // {
          //   id: "Document Selector",
          //   enabled: false,
          //   value: "Passport",
          //   type: "checkbox-select",
          //   options: ["Passport", "ID"],
          // },
          {
            id: "Auto Document Type Code Recognition",
            paramName: "auto_doc_type",
            enabled: false,
            value: false,
            type: "checkbox",
          },
          {
            id: "Mirror preview",
            paramName: "mirror_preview",
            enabled: false,
            value: false,
            type: "checkbox",
          },
          {
            id: "Document Type Code",
            enabled: false,
            paramName: "doc_type",
            value: "Kazakhstan ID",
            type: "checkbox-select",
            options: ["Kazakhstan ID", "Kazakhstan residence permit", "MRZ passport", "Other passports"],
          },
          {
            id: "Recognition Mode",
            enabled: false,
            paramName: "recognition_mode",
            value: "One side",
            type: "checkbox-select",
            options: ["One side", "Two sides"],
          },
        ],
      },
      {
        id: "eGov Digital Document by Code / QR",
        paramName: "egov-code",
        enabled: false,
        value: false,
        type: "checkbox",
      },
      {
        id: "Allow failure",
        enabled: false,
        paramName: "allow_failure",
        value: "false",
        type: "checkbox-select",
        selectValue: "false",
        options: ["true", "false"],
      },
      {
        id: "Timeout",
        enabled: false,
        paramName: "timeout",
        value: 180,
        type: "checkbox-select",
        selectValue: 60,
        options: [60, 120, 180],
      },
      {
        id: "Max retries",
        enabled: false,
        paramName: "max_retries",
        value: 3,
        type: "checkbox-select",
        selectValue: 1,
        options: [1, 2, 3],
      },
    ],
  },
  {
    id: 4,
    name: "Liveness Verification",
    paramName: "verilive",
    isActive: false,
    isOpen: false,
    description:
      "This service allows to check if a person in front of the camera is live and not trying to cheat the algorythm using a photo, a video or a mask.",
    params: [
      {
        id: "Allow failure",
        enabled: false,
        value: "false",
        paramName: "allow_failure",
        type: "checkbox-select",
        selectValue: "false",
        options: ["true", "false"],
      },
      {
        id: "Timeout",
        enabled: false,
        value: 180,
        paramName: "timeout",
        type: "checkbox-select",
        selectValue: 60,
        options: [60, 120, 180],
      },
      {
        id: "Max retries",
        enabled: false,
        value: 3,
        paramName: "max_retries",
        type: "checkbox-select",
        selectValue: 1,
        options: [1, 2, 3],
      },
    ],
  },
  {
    id: 5,
    name: "VeriFace (Face Match 1:1)",
    paramName: "veriface",
    isActive: false,
    isOpen: false,
    description:
      "This service allows to match a selfie from a liveness check with reference photo from a document or another database.",
    params: [
      {
        id: "Allow failure",
        enabled: false,
        value: "false",
        paramName: "allow_failure",
        type: "checkbox-select",
        selectValue: "false",
        options: ["true", "false"],
      },
      {
        id: "Timeout",
        enabled: false,
        value: 180,
        paramName: "timeout",
        type: "checkbox-select",
        selectValue: 120,
        options: [60, 120, 180],
      },
      {
        id: "Max retries",
        enabled: false,
        paramName: "max_retries",
        value: 3,
        type: "checkbox-select",
        selectValue: 1,
        options: [1, 2, 3],
      },
    ],
  },
  {
    id: 6,
    name: "AML / CFT Check",
    paramName: "amlcft-service",
    isActive: false,
    isOpen: false,
    description:
      "This service allows to check if a person is present in terrorist or sanctions list.",
    params: [],
  },
  {
    id: 7,
    name: "Device Switch Inlet",
    isActive: false,
    type: "inlet",
    paramName: "device-filter",
    params: [
      { id: "redirect", type: "input", value: "", placeholder: "Redirect url" },
    ],
  },
  {
    id: 8,
    name: "Flow Form (Address Data)",
    paramName: "flow-form",
    isActive: false,
    description: "This service allows to collect user's data.",
    params: [],
  },
  {
    id: 9,
    name: "User Blacklist",
    paramName: "kyc-list",
    isActive: false,
    isOpen: false,
    description:
      "This service allows to Add and filter your users with your own database.",
    params: [
      {
        id: "Allow failure",
        enabled: false,
        paramName: "allow_failure",
        value: "false",
        type: "checkbox-select",
        selectValue: "false",
        options: ["true", "false"],
      },
    ],
  },
  {
    id: 10,
    name: "Flow Interruption",
    paramName: "interrupter",
    isActive: false,
    isOpen: false,
    description: "This service allows to interrupt flow.",
    params: [
      {
        id: "Timeout",
        enabled: false,
        value: 300,
        paramName: "timeout",
        type: "checkbox-select",
        selectValue: 300,
        options: [300, 1800, 3600, 42200, 86400, 172800],
      },
    ],
  },
  {
    id: 11,
    name: "KISC",
    paramName: "kisc",
    isActive: false,
    description: "This service allows to retrieve data from KISC.",
    params: [],
  },
  {
    id: 12,
    name: "Client Card",
    paramName: "client-card",
    isActive: false,
    description: "This service allows to create client card.",
    params: [],
  },
  {
    id: 13,
    name: "Document Preview",
    paramName: "doc-preview",
    isActive: false,
    description: "This service allows you to retrieve and preview documents, as well as accept or reject them.",
    params: [
      {
        id: "documentFile",
        type: "file-upload",
        value: "",
        paramName: "document_file",
        component: FileUpload
      },
      {
        id: "Include client card as a document",
        enabled: false,
        type: "checkbox",
        paramName: "includeClientCard",
      },
      {
        id: "Rejectable",
        enabled: false,
        type: "checkbox",
        paramName: "rejectable",
      },
      {
        id: "Preview button",
        enabled: true,
        type: "checkbox",
        paramName: "preview_btn",
      }
    ],
  },
  {
    id: 14,
    name: "E-sign: Issue",
    paramName: "esign-issue",
    isActive: false,
    description: "This service allows you to issue e-sign.",
    params: [],
  },
  {
    id: 15,
    name: "E-sign: Sign",
    paramName: "esign-sign",
    isActive: false,
    description: "This service allows you to sign e-sign.",
    params: [{
      id: "documentFile",
      type: "file-upload",
      value: "",
      paramName: "document_file",
      component: FileUpload
      },
      {
        id: "Include client card as a document",
        enabled: false,
        type: "checkbox",
        paramName: "includeClientCard",
      },
    ],
  }
];
